function toggleSwitchDirective() {
    'ngInject';

    function toggleSwitchLinkFn(scope, element, attrs, ngModelCtrl) {

        scope.model = scope.model ? !!scope.model : false;

        //use this elem because event being fired twice, on label and input causing event bubble buggy behaviour
        const elem = element.find('input')[0];
        element.on('click', (e) => {
            if (e.target.className === elem.className) {
                scope.$apply(scope.toggle);
            }
        });

        element.on('keydown', (e) => {
            const key = e.which ? e.which : e.keyCode;
            if (key === 13 || key === 32) {
                // call click instead of $applying here bcoz screen reader not responding when toggle triggered by keyboard. Click event works with screen reader.
                elem.click();
            }
        });

        ngModelCtrl.$formatters.push(modelValue => modelValue);

        ngModelCtrl.$parsers.push(viewValue => viewValue);

        ngModelCtrl.$viewChangeListeners.push(() => scope.$eval(attrs.ngChange));

        ngModelCtrl.$render = () => scope.model = ngModelCtrl.$viewValue;

        scope.toggle = () => {
            if (!scope.disabled) {
                scope.model = !scope.model;
                ngModelCtrl.$setViewValue(scope.model);
            }
        };
    }

    return {
        restrict: 'EA',
        replace: true,
        require: 'ngModel',
        scope: {
            disabled: '@',
            onLabel: '@',
            offLabel: '@',
            knobLabel: '@',
            labelAria: '@'
        },
        link: toggleSwitchLinkFn,
        template: ` <div tabindex="0" class="bb-toggle-switch ats-switch switch-primary" >
                              <label  aria-label="{{labelAria}}">
                                <input class="toggler" ng-checked="!model" type="checkbox" />
                                <!-- use span for backwards compatibility-->
                                <span class="slider " ng-class="{'switch-left':model, 'switch-right':!model}">
                                     <span ng-if="!model"  aria-live="polite" class="slide-no ">{{offLabel}}</span>
                                     <span ng-if="model" aria-live="polite"  class="slide-checked ">{{onLabel}}</span>
                                </span>
                              </label>
                           </div>`
    };
}

export default toggleSwitchDirective;

angular
    .module('toggle-switch')
    .directive('toggleSwitch', toggleSwitchDirective);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/-toggle-switch/toggle-switch/toggle_switch.directive.js